import React from "react";
import styled, { CSSObject, Interpolation } from "@emotion/styled";
import * as StyledSystem from "styled-system";
import { TextAlignProperty, PositionProperty } from "csstype";
import { theme } from "@styles";

// == Types ================================================================

interface IBoxKnownProps
  extends $EmotionBaseProps,
    StyledSystem.SpaceProps,
    StyledSystem.WidthProps,
    StyledSystem.HeightProps,
    StyledSystem.MinWidthProps,
    StyledSystem.MaxWidthProps,
    StyledSystem.FontSizeProps,
    StyledSystem.BackgroundColorProps,
    StyledSystem.FlexProps,
    StyledSystem.OrderProps,
    StyledSystem.AlignSelfProps,
    // NEW
    StyledSystem.TextAlignProps,
    StyledSystem.BordersProps,
    StyledSystem.ColorProps,
    StyledSystem.BorderColorProps,
    StyledSystem.BorderRadiusProps,
    StyledSystem.BoxShadowProps,
    StyledSystem.BackgroundProps,
    StyledSystem.BackgroundImageProps,
    StyledSystem.BackgroundSizeProps,
    StyledSystem.BackgroundPositionProps,
    StyledSystem.BackgroundRepeatProps,
    StyledSystem.OpacityProps,
    StyledSystem.DisplayProps,
    StyledSystem.PositionProps,
    StyledSystem.TopProps,
    StyledSystem.RightProps,
    StyledSystem.BottomProps,
    StyledSystem.LeftProps,
    StyledSystem.LineHeightProps,
    StyledSystem.ZIndexProps {}

export interface IBoxProps
  extends IBoxKnownProps,
    Omit<React.HTMLProps<HTMLDivElement>, keyof IBoxKnownProps> {}

// == Constants ============================================================

const DEFAULT_PROPS = {
  textAlign: "left" as TextAlignProperty,
  style: {},
  borderRadius: 0,
  position: "static" as PositionProperty,
};

// == Component ============================================================

export const Box = styled<"div", IBoxProps>("div")(
  {
    boxSizing: "border-box",
    fontFamily: theme.fonts.main,
  },
  StyledSystem.space,
  StyledSystem.width,
  StyledSystem.height,
  StyledSystem.minWidth,
  StyledSystem.maxWidth,
  StyledSystem.fontSize,
  StyledSystem.backgroundColor,
  StyledSystem.flex,
  StyledSystem.order,
  StyledSystem.alignSelf,
  // NEW
  StyledSystem.textAlign,
  StyledSystem.borders,
  StyledSystem.color,
  StyledSystem.borderColor,
  StyledSystem.borderRadius,
  StyledSystem.boxShadow,
  StyledSystem.background,
  StyledSystem.backgroundImage,
  StyledSystem.backgroundSize,
  StyledSystem.backgroundPosition,
  StyledSystem.backgroundRepeat,
  StyledSystem.opacity,
  StyledSystem.display,
  StyledSystem.position,
  StyledSystem.zIndex,
  StyledSystem.left,
  StyledSystem.top,
  StyledSystem.right,
  StyledSystem.bottom,
  StyledSystem.padding,
  StyledSystem.lineHeight
);

Box.defaultProps = DEFAULT_PROPS;

// == Styles ===============================================================
